if (!customElements.get('mefyto-kit-selector')) {
  customElements.define('mefyto-kit-selector', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.form = document.getElementById(this.dataset.formId);
      this.quantityInput = this.querySelector('[data-kit-quantity]');
      if (this.form && this.quantityInput) {
        this.form.append(this.quantityInput);
      }
      this.cards = [...this.querySelectorAll('[data-kit-card]')];
      this.gifts = [...this.querySelectorAll('[data-gift]')];
      this.addEventListener('change', (event) => {
        if (event.target.matches('.mf-kit__radio')) this.updateSelection(true);
      }, { signal: this.controller.signal });
      this.addEventListener('invalid', (event) => {
        if (!event.target.matches('.mf-kit__radio')) return;
        event.preventDefault();
        this.showSelectionError();
      }, { capture: true, signal: this.controller.signal });
      this.form?.addEventListener('submit', (event) => {
        if (!this.selectedCard()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showSelectionError();
          return;
        }
        this.updateSelection(false);
      }, { capture: true, signal: this.controller.signal });
      this.form?.addEventListener('formdata', (event) => {
        const card = this.selectedCard();
        if (card) event.formData.set('quantity', card.dataset.quantity);
      }, { signal: this.controller.signal });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId || !event.data.variant) return;
          this.dataset.basePrice = event.data.variant.price;
          this.dataset.comparePrice = event.data.variant.compare_at_price || event.data.variant.price;
          this.updatePrices();
          this.updateSelection(false);
        });
      }
      this.updateSelection(false);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribeVariant?.();
      if (this.quantityInput?.closest('form') === this.form) this.append(this.quantityInput);
    }

    selectedCard() {
      return this.cards.find(card => card.querySelector('.mf-kit__radio').checked);
    }

    showSelectionError() {
      const error = this.querySelector('[data-kit-error]');
      if (error) error.hidden = false;
      this.cards[0]?.querySelector('.mf-kit__radio').focus();
    }

    updateSelection(announce) {
      const selected = this.selectedCard();
      if (this.quantityInput) {
        this.quantityInput.disabled = !selected;
        this.quantityInput.value = selected?.dataset.quantity || '';
      }
      const error = this.querySelector('[data-kit-error]');
      if (selected && error) error.hidden = true;
      this.cards.forEach(card => {
        const active = card === selected;
        card.classList.toggle('is-selected', active);
        const details = card.querySelector('.mf-kit__details');
        if (details) details.hidden = !active;
      });
      const unlockedTitles = [];
      this.gifts.forEach(gift => {
        const unlocked = !!selected && selected.dataset[gift.dataset.gift] === 'true';
        gift.classList.toggle('is-locked', !unlocked);
        gift.querySelector('[data-gift-status]').textContent = unlocked ? gift.dataset.unlockedLabel : gift.dataset.lockedLabel;
        if (unlocked) unlockedTitles.push(gift.dataset.giftTitle);
      });
      if (announce && selected) {
        this.querySelector('[data-kit-status]').textContent = this.dataset.announcement.replace('__title__', selected.dataset.title).replace('__gifts__', unlockedTitles.join(', '));
      }
    }

    updatePrices() {
      const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: this.dataset.currency }).format(cents / 100);
      this.cards.forEach(card => {
        const quantity = Number(card.dataset.quantity);
        const discount = Number(card.dataset.discount);
        const base = Number(this.dataset.basePrice);
        const fixedDiscount = Number(card.dataset.fixedDiscount) || 0;
        const each = fixedDiscount > 0 ? Math.max(0, base - fixedDiscount) : Math.round(base * (100 - discount) / 100);
        const total = each * quantity;
        const compare = (discount === 0 && fixedDiscount === 0 ? Math.max(base, Number(this.dataset.comparePrice)) : base) * quantity;
        card.querySelector('[data-kit-price]').textContent = money(total);
        const compareElement = card.querySelector('[data-kit-compare]');
        compareElement.textContent = money(compare);
        compareElement.hidden = this.dataset.showCompare !== 'true' || compare <= total;
        const unit = card.querySelector('[data-unit-price]');
        if (unit) unit.textContent = this.dataset.unitTemplate.replaceAll('[price]', money(each)).replaceAll('[saving]', money(compare - total)).replaceAll('[discount]', `${discount}%`);
      });
    }
  });
}
